import { gql } from '@apollo/client'

export const PERMISSIONS = gql`
query {
  permissions {
    canAccess
    canSeeSAID
  }
}`

export const SEARCH_EMPLOYEES = gql`
query ($text: String!) {
  searchEmployees(text: $text) {
    id
    preferredName
    firstName
    lastName
    jobTitle
    department
  }
}
`

export const GET_EMPLOYEE = gql`
query ($id: ID!) {
  employee(id: $id) {
    id
    firstName
    preferredName
    lastName
    jobTitle
    cellphone
    email
    department
    manager {
      id
      firstName
      preferredName
      lastName
      jobTitle
    }
    reports {
      id
      firstName
      preferredName
      lastName
      jobTitle
    }
  }
}
`

export const GET_EMPLOYEE_WITH_SAID = gql`
query ($id: ID!) {
  employee(id: $id) {
    id
    SAID
    firstName
    preferredName
    lastName
    jobTitle
    cellphone
    email
    department
    manager {
      id
      firstName
      preferredName
      lastName
      jobTitle
    }
    reports {
      id
      firstName
      preferredName
      lastName
      jobTitle
    }
  }
}
`
